/**
 * Stories for 404 handle this
 */
/* eslint-disable local-rules/require-storybook-documentation */

import { Box } from '@zillow/constellation-10';
import { FunctionComponentWithChildren } from 'src/utils/types';

export const CatWrapper: FunctionComponentWithChildren = ({ children }) => (
    <Box
        css={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            zIndex: 1,
            height: {
                base: '360px',
                sm: `{sizes.desktopHeight}`,
            },
            bottom: { md: 0 },
            position: { md: 'absolute' },
        }}>
        {children}
    </Box>
);
